<template>
  <div>
    <div :id="containerId" :style="{height:height+'px',width:width+'px'}">
      {{msg}}<span v-if="downloadPlugin"><a class="color-link" :href="getFileUrl()" target="_blank" title="点击下载视频插件">
          下载插件
        </a></span>
    </div>
  </div>
</template>
<script>
import { getVideoWebPlugin } from '@/api/documents/documents'
import { fileServer } from '@/api/common/upload'
import { newGuid, tryToInt } from '@/configs/functions'

export default {
  name: "cbHikVideo",
  props: {
    width: {
      type: Number,
      default: 1000
    },
    height: {
      type: Number,
      default: 500
    },
    //监控点编号 a10a0a91c67742f1a84fef9a41df4eec ==deviceNumber
    videoCode: {
      type: String,
      default: ""
    },
    //多窗口播放时，需要设置各个串口的监控点编码:
    codeList: {
      type: Array,
      default: []
    },
    //playMode指定模式的布局
    layout: {
      type: String,
      default: "1x1"
    },
    /** 播放窗口数量，跟layout有关 */
    wndNum: {
      type: Number,
      default: 1
    },
    refTarget: {
      type: String,
      default: ""
    },
    isPlayBack: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      wndList: [],//播放窗口列表，存窗口id和监控点编码。通过监控点编码判断该窗口是否有在使用，在回调方法中更新
      playCount: 0,//多窗口时，播放过的视频数据。用这个来播放窗口
      playing: false,
      playTitle: '',
      playback_start: '',//视频回放，开始时间
      playback_end: '',//视频回放，结束时间
      oWebControl: null,
      playBackDateRange: [],
      msg: "",
      initCount: 0,
      pubKey: "",
      recordLocation: 1,//录像存储位置：0-中心存储，1-设备存储 回放时使用
      ////////////////////////////////// 请自行修改以下变量值	////////////////////////////////////
      //综合安防管理平台提供的appkey，必填
      appkey: "22981425",// "22804966",
      //综合安防管理平台提供的secret，必填
      secretKey: "poQBWx3qBl3qiMBJCdVc",//"0uOkzN5LpZTpS0ERLg1J",
      //综合安防管理平台IP地址，必填
      ip: "39.107.83.190",//"112.125.27.147",
      //综合安防管理平台端口，若启用HTTPS协议，默认443
      port: 1443,//443,
      //抓图存储路径"D:\\SnapDir"
      snapDir: "D:\\SnapDir",
      //紧急录像或录像剪辑存储路径 "D:\\VideoDir"
      videoDir: "D:\\VideoDir",
      //playMode指定模式的布局
      // layout: "1x1",
      //是否启用HTTPS协议与综合安防管理平台交互，是为1，否为0
      enableHTTPS: 1,
      //加密字段，默认加密领域为secret
      encryptedFields: "secret",
      //是否显示工具栏，0-不显示，非0-显示
      showToolbar: 1,
      //是否显示智能信息（如配置移动侦测后画面上的线框），0-不显示，非0-显示
      showSmart: 1,
      //自定义工具条按钮
      buttonIDs: "0,16,256,257,258,259,260,512,513,514,515,516,517,768,769",

      streamMode: 1, //主子码流标识：0-主码流，1-子码流
      transMode: 1, //传输协议：0-UDP，1-TCP
      gpuMode: 0, //是否启用GPU硬解，0-不启用，1-启用
      wndId: -1, //播放窗口序号（在2x2以上布局下可指定播放窗口）
      ////////////////////////////////// 请自行修改以上变量值	////////////////////////////////////
      //指定容器id
      containerId: 'divHikPlay',
      downloadPlugin: false,//下载插件
      plugnFile: { Id: 0, TempGuid: '', OriginalFileName: '' }//插件实体
    };
  },
  created() {
    this.containerId = 'hikVideo' + newGuid()
  },
  mounted() {
    var opt = window.baseConfig.WebControl
    this.appkey = opt.Appkey
    this.secretKey = opt.SecretKey
    this.ip = opt.IP
    this.port = opt.Port
    this.showSmart = opt.showSmart
  },
  beforeDestroy() {
    this.destroyPlugin()
  },
  methods: {
    getPluginFile() {
      getVideoWebPlugin().then((response) => {
        let data = response.data
        if (data && data.Id > 0) {
          this.plugnFile = data
          this.downloadPlugin = true
        }
      })
    },
    getFileUrl() {
      let f = this.plugnFile
      return fileServer(f.Id, f.TempGuid, f.OriginalFileName)
    },
    initPlugin() {
      this.destroyPlugin()
      this.oWebControl = new WebControl({
        szPluginContainer: this.containerId, // 指定容器id
        iServicePortStart: 15900, // 指定起止端口号，建议使用该值
        iServicePortEnd: 15909,
        szClassId: "23BF3B0A-2C56-4D97-9C03-0CB103AA8F11", // 用于IE10使用ActiveX的clsid
        cbConnectSuccess: () => {
          console.log('cbConnectSuccess')
          this.msg = '';
          // 创建WebControl实例成功
          this.oWebControl
            .JS_StartService("window", {
              // WebControl实例创建成功后需要启动服务
              dllPath: "./VideoPluginConnect.dll" // 值"./VideoPluginConnect.dll"写死
            })
            .then(
              () => {
                // 启动插件服务成功
                this.oWebControl.JS_SetWindowControlCallback({
                  // 设置消息回调
                  cbIntegrationCallBack: oData => {
                    // console.log('设置消息回调')
                    this.cbIntegrationCallBack(oData)
                    // console.log(JSON.stringify(oData.responseMsg));
                  }
                });
                //JS_CreateWnd创建视频播放窗口，宽高可设定
                this.oWebControl.JS_CreateWnd(this.containerId, this.width, this.height).then(() => {
                  console.log('JS_CreateWnd')
                  this.init(); // 创建播放实例成功后初始化
                });
              },
              () => {
                // 启动插件服务失败
                this.msg = "插件启动失败"
              }
            );
        },
        cbConnectError: () => {
          // 创建WebControl实例失败
          this.oWebControl = null;
          this.msg = "插件未启动，正在尝试启动，请稍候...";
          WebControl.JS_WakeUp("VideoWebPlugin://"); // 程序未启动时执行error函数，采用wakeup来启动程序
          this.initCount++;
          this.downloadPlugin = false
          if (this.initCount < 3) {
            setTimeout(() => {
              this.initPlugin();
            }, 3000);
          } else {
            this.getPluginFile()
            this.msg = "插件启动失败，请检查插件是否安装！";
          }
        },
        cbConnectClose: bNormalClose => {
          // 异常断开：bNormalClose = false
          // JS_Disconnect正常断开：bNormalClose = true
          console.log("cbConnectClose", bNormalClose);
          this.oWebControl = null;
          this.msg = '';
        }
      });
    },
    destroyPlugin() {
      if (this.oWebControl != null) {
        this.oWebControl.JS_HideWnd(); //先让窗口隐藏，规避可能的插件窗口滞后于浏览器消失问题 
        this.oWebControl.JS_Disconnect().then(() => {
          // 断开与插件服务连接成功
        }, () => {
          // 断开与插件服务连接失败
        });
        this.oWebControl = null
      }
      window.onscroll = null
      window.onresize = null
    },
    hideWnd() {
      //隐藏视频窗口
      this.oWebControl.JS_HideWnd();
    },
    showWnd() {
      //隐藏视频窗口
      this.oWebControl.JS_ShowWnd();
    },
    init() {
      this.getPubKey(() => {
        var argu = {
          appkey: this.appkey, //API网关提供的appkey
          secret: this.setEncrypt(this.secretKey), //API网关提供的secret
          ip: this.ip, //API网关IP地址
          playMode: this.isPlayBack ? 1 : 0, //播放模式：0-预览，1-回放（决定显示预览还是回放界面）
          port: this.port, //端口
          snapDir: this.snapDir, //抓图存储路径
          videoDir: this.videoDir, //紧急录像或录像剪辑存储路径
          layout: this.layout, //布局
          enableHTTPS: this.enableHTTPS, //是否启用HTTPS协议
          encryptedFields: this.encryptedFields, //加密字段
          showToolbar: this.showToolbar, //是否显示工具栏
          showSmart: this.showSmart, //是否显示智能信息
          buttonIDs: this.buttonIDs //自定义工具条按钮
        }
        this.oWebControl
          .JS_RequestInterface({
            funcName: "init",
            argument: JSON.stringify(argu)
          })
          .then(oData => {
            console.log('JS_RequestInterface init', oData)
            this.toResize(); // 初始化后resize一次，规避firefox下首次显示窗口后插件窗口未与DIV窗口重合问题
            // this.registerResizeEvent();
            //自动播放
            if (this.videoCode != '' && !this.codeList) {
              console.log('自动播放')
              this.start();
            }
            else if (this.codeList && this.codeList.length > 0) {
              console.log('批量预览')
              //批量预览
              this.startMulit(null, false);
            }
            window.eventBus.$emit('cbHik_init', {
              targetId: this.refTarget
            })
          });
      });
    },
    getPubKey(callback) {
      this.oWebControl
        .JS_RequestInterface({
          funcName: "getRSAPubKey",
          argument: JSON.stringify({ keyLength: 1024 })
        })
        .then(oData => {
          console.log("JS_RequestInterface getPubKey", oData);
          if (oData.responseMsg.data) {
            this.pubKey = oData.responseMsg.data;
            callback();
          }
        });
    },
    //RSA加密
    setEncrypt(value) {
      var encrypt = new JSEncrypt();
      encrypt.setPublicKey(this.pubKey);
      return encrypt.encrypt(value);
    },
    /** 回调函数
     * {
     *    type: 1, // 消息类型，取值详见 3.12.*
     *    msg:
     *    {
     *      wndId: 1, // 窗口序号，从 1 开始
     *      result: 0x0100, // 0x0100-正在播放 0x0200-空闲
     *      cameraIndexcode: "58e90452772a4d9da7c7ba4cef26dbf0", // 监控点编号
     *      expand: "" // 扩展字段
     *    }
     * }
     * 
    */
    cbIntegrationCallBack(oData) {
      console.log('cbIntegrationCallBack', oData)
      if (oData) {
        const resData = oData.responseMsg
        //oData.responseMsg解析｛type:number, msg:object ｝
        if (resData) {
          const type = tryToInt(resData.type)
          const msgObj = resData.msg
          /*
type: 1, // 选中窗口消息msg:
msg:{
 wndId: 1, // 窗口序号
 result: 0x0100, // 0x0100-正在播放 0x0200-空闲
 cameraIndexCode: "58e90452772a4d9da7c7ba4cef26dbf0" // 监控点编号
}
-------------------------------------------------
type: 2, 预览/回放播放消息
msg:{
 wndId: 1, // 窗口序号
 result: 0x0300, // 0x0300-开始播放 0x0301-播放失败 0x0302-播放异常，0x0330-播放结束
 cameraIndexCode: "58e90452772a4d9da7c7ba4cef26dbf0" // 监控点编号
}
-------------------------------------------------
type: 6, // 切换布局
msg:{
 layout: "2x2", // 布局名称
 wndNum: 4
}
          */
          //2预览/回放播放消息
          if (type == 2) {
            //获取窗口状态，做code清理
            if (this.wndList & this.wndList.length > 0) {
              if (msgObj && msgObj.wndId) {
                this.wndId = parseInt(msgObj.wndId)
                if (msgObj.cameraIndexcode == '') {
                  let wndObj = this.wndList.find((v) => v.wndId == this.wndId)
                  if (wndObj) {
                    //清理编码
                    wndObj.code = ''
                  }
                }
              }
            }
          }
          //6切换布局 msg={layout: "2x2","wndNum": 4 }
          if (type == 6) {
            if (msgObj && msgObj.wndNum) {
              if (this.wndNum != msgObj.wndNum) {
                const newNum = msgObj.wndNum
                //切换布局后，更新播放列表
                if (this.wndList && this.wndList.length > 0) {
                  //如果窗口数量减少，就从播放列表中删除后面几项
                  //如果窗口数量增加，就在原播放列表后添加
                  var newWndList = []
                  for (var i = 0; i < newNum; i++) {
                    if (i < this.wndNum) {
                      newWndList.push(this.wndList[i])
                    }
                    else {
                      //生成视频窗口参数
                      newWndList.push({ code: '', wndId: i + 1 })
                    }
                  }
                }
                this.wndList = newWndList
                this.wndNum = newNum
                // this.$emit('update:wndNum', this.wndNum)
              }
            }
          }
        }
      }
      if (this.wndNum > 0) {
        //更新播放列表
        window.eventBus.$emit('cbHik_refreshPlayList', {
          targetId: this.refTarget,
          playList: this.wndList
        })
      }
    },
    play(opt) {
      let wndNum = this.wndNum
      if (!this.wndList) {
        this.wndList = []
      }
      //生成窗口播放状态表，存窗口id，播放编码
      if (wndNum > 0 && this.wndList.length == 0) {
        this.playCount = wndNum
        //生成视频窗口参数
        for (var i = 0; i < wndNum; i++) {
          this.wndList.push({ code: '', wndId: i + 1 })
        }
      }
      if (opt) {
        if (opt.code) {
          this.videoCode = opt.code
        }
        if (opt.storageType) {
          this.recordLocation = opt.storageType - 1
        }
        let wndId = null
        //判断当前视频是否在播放列表中
        var cur = this.wndList.find((v) => v.code == opt.code)
        if (cur) {
          //在播放列表中就在他自己的窗口中播放
          wndId = cur.wndId
        }
        //没有在播放列表中，就找一个空窗口播放
        if (wndId == null) {
          // 获取是否有空窗口，没有空窗口的话，就由视频插件自行判断窗口
          var play = this.wndList.find((v) => v.code == '')
          if (play) {
            play.code = opt.code
            wndId = play.wndId
          }
          else {
            this.playCount++
          }
        }
        this.wndId = wndId
      }
      if (this.wndId == null) {
        this.wndId = 1
        if (wndNum > 1 && this.playCount > wndNum) {
          var mod = this.playCount % wndNum
          if (mod == 0) {
            mod = wndNum
          }
          var getWnd = this.wndList.find((v) => v.wndId == mod)
          if (getWnd) {
            //设置窗口中对应窗口的播放编码为当前编码
            getWnd.code = opt.code
          }
          this.wndId = mod
        }
      }
      window.eventBus.$emit('cbHik_refreshPlayList', {
        targetId: this.refTarget,
        playList: this.wndList
      })
      this.start()
    },
    /**根据视频数量，动态获取窗口布局 */
    setLayout(videoCount) {
      var layoutList = [
        { name: '1x1', count: 1 },
        { name: '1x2', count: 2 },
        { name: '1+2', count: 3 },
        // { name: '1x4', count: 4 },
        { name: '2x2', count: 4 },
        { name: '1+5', count: 6 },
        { name: '3+4', count: 7 },
        { name: '1+7', count: 8 },
        //{ name: '1+8', count: 9 },
        { name: '3x3', count: 9 },
        { name: '1+9', count: 10 },
        // { name: '4+9', count: 13 },
        { name: '1+12', count: 13 },
        { name: '1+1+12', count: 14 },
        { name: '4x4', count: 16 },
        { name: '1+16', count: 17 },
        { name: '4x6', count: 24 },
        { name: '5x5', count: 25 }
      ];
      var ly = layoutList.find(v => v.count >= videoCount);
      var layout = ly ? ly.name : '1x1';
      this.oWebControl.JS_RequestInterface({
        funcName: "setLayout",
        argument: JSON.stringify({ layout: layout })
      }).then(oData => {
        console.log('setLayout', oData)
      });
    },
    /** 批量视频预览 codes:{code,sm}[]*/
    startMulit(codes, setLayout) {
      //播放前，先停止正在播放的
      this.stopAll()

      let list = []
      let codeList = this.codeList
      let smList = []
      if (codes && codes.length > 0) {
        codeList = codes.map(v => { return v.code })
        smList = codes.map(v => { return v.sm })
      }
      if (codeList && codeList.length > 0) {
        list = codeList.map((v, i) => {
          let code = v.replace(/(^\s*)/g, "").replace(/(\s*$)/g, "")
          let sm = smList && smList.length > i ? smList[i] : this.streamMode
          return {
            cameraIndexCode: code, //监控点编号
            streamMode: sm, //主子码流标识
            transMode: this.transMode, //传输协议
            gpuMode: this.gpuMode, //是否开启GPU硬解
            wndId: i + 1, //可指定播放窗口
            ezvizDirect: 0//是否直连萤石预览 未指定或为 0-非直连 其它值-直连
          }
        })
      }
      if (list.length > 0) {
        if (setLayout) {
          //根据视频数量，动态获取窗口布局
          this.setLayout(list.length);
        }
        /**
         * 根据监控点编号批量视频预览 startMultiPreviewByCameraIndexCode
         * 根据监控点编号批量录像回放 startMultiPlaybackByCameraIndexCode
         * **有个问题，批量预览后焦点会在最后一个视频上，这边把传入的list做了倒序.reverse()处理来解决
        */
        let fnName = this.isPlayBack ? "startMultiPlaybackByCameraIndexCode" : "startMultiPreviewByCameraIndexCode";
        console.log(fnName, list)
        this.oWebControl.JS_RequestInterface({
          funcName: fnName,
          argument: { list: list }//.reverse()
        })
          .then(oData => {
            //设置第一个窗口为当前激活窗口
            //set wndId=1???
            console.log('JS_RequestInterface startMulti', oData)
          });
      }
    },
    //回放
    startPlayBack(opt) {
      if (opt.videoCode == '') {
        this.$message.warning('请选择监控点编号！');
        return false;
      }
      this.videoCode = opt.videoCode;
      if (opt.startDate == null || opt.startDate == ''
        || opt.endDate == null || opt.endDate == '') {
        this.$message.warning('请选择视频回放时间段！');
        return false;
      }
      else {
        //回放开始时间戳，必填
        var tsStart = new Date(opt.startDate).getTime();
        //回放结束时间戳，必填
        var tsEnd = new Date(opt.endDate).getTime();
        this.playback_start = Math.floor(tsStart / 1000).toString();
        this.playback_end = Math.floor(tsEnd / 1000).toString();
        if (opt.streamMode != null) {
          this.streamMode = opt.streamMode
        }
        this.start();
      }
    },
    //开始播放
    start() {
      if (this.videoCode == "" && this.codeList && this.codeList.length > 0) {
        if (this.wndId < 0) {
          this.wndId = 0
        }
        this.videoCode = this.codeList[this.wndId]
      }
      var cameraIndexCode = this.videoCode; //获取输入的监控点编号值，必填
      cameraIndexCode = cameraIndexCode.replace(/(^\s*)/g, "");
      cameraIndexCode = cameraIndexCode.replace(/(\s*$)/g, "");
      var argu = {
        cameraIndexCode: cameraIndexCode, //监控点编号
        streamMode: this.streamMode, //主子码流标识
        transMode: this.transMode, //传输协议
        gpuMode: this.gpuMode, //是否开启GPU硬解
        wndId: this.wndId //可指定播放窗口
      };
      if (this.isPlayBack) {
        //录像存储类型：0-中心存储，1-设备存储
        argu.recordLocation = 1;
        //录像查询开始时间戳，单位：秒
        argu.startTimeStamp = this.playback_start;
        //录像结束开始时间戳，单位：秒
        argu.endTimeStamp = this.playback_end;
      }
      let fnName = this.isPlayBack ? "startPlayback" : "startPreview";
      console.log(fnName, argu)
      this.oWebControl.JS_RequestInterface({
        funcName: fnName,
        argument: JSON.stringify(argu)
      })
        .then(oData => {
          console.log(fnName, oData)
        });
    },
    //停止全部
    stopAll() {
      let fnName = this.isPlayBack ? "stopAllPlayback" : "stopAllPreview";
      this.oWebControl.JS_RequestInterface({
        funcName: fnName
      })
        .then(oData => {
          // console.log(fnName, oData)
        });
    },
    setResize(width, height) {
      this.width = width
      this.height = height
      this.toResize();
    },
    toResize() {
      console.log('JS_Resize', this.width, this.height)
      if (this.oWebControl != null) {
        this.oWebControl.JS_Resize(this.width, this.height);
      }
    },
    registerResizeEvent() {
      window.onscroll = () => {
        this.toResize();
      }
      window.onresize = () => {
        this.toResize();
      }
    }
  }
};
</script>

<style scoped></style>
